import { usePageCharts } from '~/api/hooks/useCharts'
import {
  useReviewPageState,
  useComparisonState,
  ReviewPageScaffold,
  PageTiles,
} from '~/components/ReviewPage'
import { PAGE_DEFAULTS } from '~/components/ReviewPage/pageDefaults'

export function MarketingInvests() {
  const state = useReviewPageState({
    pageId: 'MarketingInvests',
    factTable: 'media_national',
    defaultKpi: PAGE_DEFAULTS.MarketingInvests,
    archetype: 'status',
  })
  const compare = useComparisonState(state.fromIso, state.toIso)
  const charts = usePageCharts(state.pageId, state.kpi)
  return (
    <ReviewPageScaffold title="Marketing Invests" state={state} compare={compare}>
      <PageTiles charts={charts} state={state} compare={compare} pageSlug="marketinginvests" />
    </ReviewPageScaffold>
  )
}
